// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-adyen-redirect-tsx": () => import("./../../../src/pages/adyen/redirect.tsx" /* webpackChunkName: "component---src-pages-adyen-redirect-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

